import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RotationMeter from './RotationKpiMeter';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import KpiDescription from './KpiDescription';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiModels from '../../../models/kpiModels';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';

import * as objectConstants from '../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class ScoreIntroduction extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            status: objectConstants.STATUS_NOT_STARTED,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            bite_id: this.props.callbacks.getBiteId(),
            score_kpi: appHelper.getBiteById(this.props.callbacks.getBiteId()).score_kpi,
            kpis: appHelper.getBiteById(this.props.callbacks.getBiteId()).performance_kpis,
            locale: appHelper.getLocalData(this.props.screenObject),
            score_kpi_locale: {},
            showProgressionButton: false,
            screenStatus:"",
            checkComplete: false,
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(),this.props.callbacks.getScreenId(),this.props.screenObject.asset_id),
            continue_label: appHelper.getLocaleString("continue_label")
        };
        this.getLocale = this.getLocale.bind(this);
        this.show = this.show.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);

    }

    componentDidMount() {
        this.getLocale();
        this.getScreenStatus();
        this.show();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.bite_id),
                score_kpi_locale: appHelper.getLocalData(this.state.score_kpi),
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    componentDidUpdate() {
        if(this.state.checkComplete){
            this.onComplete();
        }

    }

    scrollToTop() {
        if(this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
            let object = this.refs[`${this.state.score_kpi.kpi_id}_description`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                scrollTo(object.offsetTop);
            }, objectConstants.SCROLL_TO);
        }
    }

    getScreenStatus(){
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        if(this.state.screenStatus === objectConstants.STATUS_COMPLETE){
            this.onComplete();
        }else{
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)){
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                }else{
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }

            if(objectUserData.status === objectConstants.STATUS_COMPLETE){
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true});
            }else{
                this.setState({checkComplete: true});
            }

        }

    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.score_kpi);
        this.setState({score_kpi_locale: Object.assign({}, locale)});
    }

    show() {
        let optionRef = this.refs[`${this.state.score_kpi.kpi_id}_description`];
        TweenLite.set(optionRef, {height: "auto", opacity: 1});
        TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
            height: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.getObjectStatus);
    }

    onComplete() {
        this.setState({checkComplete: false});
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if(appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)){
            if(!hasNextObject) {
                this.handleProgression();
                this.enableProgression();
            }else{
                this.enableProgression();
            }

        }else{
            this.handleProgression();
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    onProgressionBtnClicked(){
        this.setState({showProgressionButton: false});
        if(this.props.callbacks.hasNextObject(this.props.index)){
            this.handleProgression();
        }else{
            this.props.callbacks.navigateToNextScreen();
        }
    }

    render() {
        return (
            <div className={`object-container`} ref={`${this.state.score_kpi.kpi_id}_description`}>
                {
                    this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null  && this.state.locale.label.length > 0
                        ?
                        <h4 className="bold" dangerouslySetInnerHTML={{__html:this.state.locale.label}} />
                        :
                        null
                }
                {
                    appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0  && (this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_PRIMARY)
                        ?
                        <div dangerouslySetInnerHTML={{__html:this.state.locale.description}} />
                        :
                        null
                }

                {this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_PRIMARY
                    ?
                    <div ref={`${this.state.score_kpi.kpi_id}_description`} className="kpi-overview-panel">

                        <div className="kpi-overview-row">
                            <KpiDescription kpi={this.state.score_kpi}
                                            bite_id={this.state.bite_id}
                                            callbacks={this.state.objectCallbacks}/>
                        </div>
                    </div>
                    :
                    null
                }

                {this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH
                    ?
                    <br/>
                    :
                    null
                }

                {
                    appHelper.isDefined(this.state.locale.secondary_metrics_description) && this.state.locale.secondary_metrics_description !== null && this.state.locale.secondary_metrics_description.length > 0  && (this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_SECONDARY)
                        ?
                        <div dangerouslySetInnerHTML={{__html:this.state.locale.secondary_metrics_description}} />
                        :
                        null
                }
                {
                    appHelper.isDefined(this.state.locale.secondary_metrics_description) && this.state.locale.secondary_metrics_description !== null && this.state.locale.secondary_metrics_description.length > 0 && (this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_SECONDARY)
                        ?
                        <br/>
                        :
                        null
                }


                {this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_BOTH || this.state.screenObject.display_scope === objectConstants.KPI_DISPLAY_SCOPE_SECONDARY
                    ?
                    <div className="kpi-overview-panel">
                        {this.state.kpis.map(kpi =>
                            <KpiDescription key={kpi.kpi_id}
                                            kpi={kpi}
                                            bite_id={this.state.bite_id}
                                            callbacks={this.state.objectCallbacks}/>
                        )}
                    </div>
                    :
                    null
                }


                {this.state.showProgressionButton
                    ? <Button label={this.state.continue_label}
                              id={`${this.state.screenObject}_button`}
                              onClick={this.onProgressionBtnClicked}/>
                    : null
                }
            </div>
        );
    }
}

ScoreIntroduction.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

ScoreIntroduction.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScoreIntroduction);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/ScoreIntroduction.js
 **/